import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface InputPhoneFieldProps {
  label?: string;
  placeholder: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  rounded?:number
  defaultValue?:string
  readononly?:boolean
}

const InputPhoneField: React.FC<InputPhoneFieldProps> = ({ label, placeholder, register, error,rounded,defaultValue,readononly=false }) => {
  return (
    <div className="mb-4 w-full">
      {label && (
        <label className="block text-sm font-semibold text-Black mb-2 capitalize">
          {label}
        </label>
      )}
      <div className={`flex w-full items-center border rounded-[${rounded?rounded:'20'}px] p-0 focus-within:ring-2 focus-within:ring-primary border-LightGrey3`}>
        <span className="px-3 text-DarkGrey3 border-e border-LightGrey3 font-bold flex-shrink-0">+966</span>
        <input
          readOnly={readononly}
          type="text"
          placeholder={placeholder}
          defaultValue={defaultValue}
          {...register}
          className="flex-1 min-w-0 p-3 outline-none border-none rounded-[20px]"
        />
      </div>
      {error && <span className="text-danger text-sm mt-1 block">{error.message}</span>}
    </div>
  );
};

export default InputPhoneField;
